var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-checkbox',_vm._g(_vm._b({attrs:{"value":"1","label":_vm.variable,"type":"checkbox","required":""}},'v-checkbox',_vm.$attrs,false),_vm.$listeners),[_vm._t("append-outer",null,{"slot":"append-outer"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }